<template>
  <container :class="['page-wrapper']">
    <alert type="success" v-model="comingSoon">{{ $lang.underConstruction }}</alert>
    <all-section-blocks :title="true" :tooltip="false" />
  </container>
</template>
<script>
export default {
  name: 'PageBareboneProp',
  data () {
    return {
      comingSoon: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/content/barebone-prop.vue